import { useEffect, useState } from 'react';

import { useEmojiEditions } from '../useEmojiEditions';
import { useEmojiWasm } from '../useEmojiWasm';

import {
    type EmojiCategory,
    type EmojiCharacterSetFilterData,
    type EmojiCollection,
    type EmojiCollectionData,
    EmojiFilter,
} from './types';

export type EmojiCollectionReturn = ReturnType<typeof useEmojiCollection>;

export function useEmojiCollection() {
    const { editions } = useEmojiEditions();
    const { emojiWasm, error } = useEmojiWasm();

    const [loading, setLoading] = useState(true);
    const [collection, setCollection] = useState<EmojiCollection>();

    useEffect(() => {
        // Do not run again once we have set the collection.
        if (emojiWasm && !collection) {
            const characterSet = new emojiWasm.CharacterSet(editions);
            const categories: EmojiCategory[] = characterSet.nonEmptyGroups();

            const result = categories.reduce<EmojiCollection>((collected, category) => {
                const filterData: EmojiCharacterSetFilterData[] = characterSet.filter(category, EmojiFilter.Group);
                const collectionData: EmojiCollectionData[] = filterData.map(([glyph, name, shortName]) => ({
                    glyph,
                    name,
                    shortName,
                }));

                return {
                    ...collected,
                    [category]: collectionData,
                };
            }, {});

            setLoading(false);
            setCollection(result);
        }
    }, [editions, emojiWasm, collection]);

    return {
        collection,
        loading,
        error,
    };
}
